
import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import NotificationCenter from '@/domains/notifications/components/NotificationCenter.vue'
import LogoutModal from '../../auth/components/LogoutModal.vue'
import { authAxios } from '@/domains/auth/utils'

@Component({
  components: { LogoutModal, NotificationCenter }
})
export default class ToolbarComponent extends Vue {
  get logoutModal () {
    return this.$refs.logoutModal as LogoutModal
  }

  async logout () {
    await authAxios.post('/logout')
    await this.$store.commit('auth/logout')
    this.$router.push({ name: 'login' })
  }

  viewProfile() {
    if (this.$route.name !== 'profile') {
      this.$router.push({ name: 'profile' })
    }
  }
}
